import { Text } from "@/elements"
import { EmptyChat } from "@/svg/EmptyChat"
import React, { FC } from "react"

interface Props {}

export const ChannelEmptyPlaceholder: FC<Props> = ({}) => {
  return (
    <div className="relative flex h-full w-full flex-col items-center justify-center gap-2">
      <EmptyChat />
      <Text>No chats here yet...</Text>
    </div>
  )
}
